import { Stack } from "@mui/material";

import { MessageBubble } from "./messageBubble";
import { AiChatMessageGroup } from "types/auth";

type Props = {
  group: AiChatMessageGroup;
  showStartupText?: boolean;
};

export function MessageGroupBubble({
  group,
  showStartupText = false,
}: Props) {
  const isUser = group.role === "user";

  return (
    <Stack spacing={0.5} alignItems={isUser ? "flex-end" : "flex-start"}>
      {group.messages.map((msg, index) => (
        <MessageBubble
          key={msg.id}
          message={msg}
          showStartupText={showStartupText && index === 0}
        />
      ))}
    </Stack>
  );
}